import { useQuery } from '@apollo/client';
import { DictionaryItem, QueryListResponse } from 'global';

import { calendarApi } from './index';
import { DealActivityAPINameSpace } from '../../api/types';

export function useCalendarFormOptions(accountId: string | null) {
  const { data: accountOptions, loading: accountOptionsLoading } = useQuery<
    DealActivityAPINameSpace<QueryListResponse<DictionaryItem>>
  >(calendarApi.events.queries.accountOptions);

  const { data: contactOptions, loading: contactOptionsLoading } = useQuery<
    DealActivityAPINameSpace<QueryListResponse<DictionaryItem>>
  >(calendarApi.events.queries.contactOptions, {
    skip: !accountId,
    variables: {
      input: {
        accountId,
      },
    },
  });

  return {
    contactOptionsLoading,
    accountOptionsLoading,
    accountOptions: accountOptions?.dealActivity?.result?.list ?? [],
    contactOptions: contactOptions?.dealActivity?.result?.list ?? [],
  };
}
